export default "__VITE_ASSET__BJmKLNc___"